module.exports = __webpack_public_path__ + "img/public/SiteIcons/calendarIconNew.svg?0a1cfaa3";